import { useEffect } from 'react';
import { useTheme } from 'next-themes';

/**
 * Hook to handle keyboard shortcut for theme toggle (Ctrl+Shift+T)
 */
export const useThemeShortcut = () => {
  const { theme, setTheme } = useTheme();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Ctrl+Shift+T (Windows/Linux) or Cmd+Shift+T (Mac)
      if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'T') {
        event.preventDefault();
        // Cycle through themes: light -> dark -> system -> light
        if (theme === 'light') {
          setTheme('dark');
        } else if (theme === 'dark') {
          setTheme('system');
        } else {
          setTheme('light');
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [theme, setTheme]);
};
